import React from 'react';
import { cn } from '../../utils/cn';

export interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ eyebrow, title, subtitle, actions, className }) => {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div className="flex flex-col gap-1.5 min-w-0">
        {eyebrow && (
          <span className="text-xs font-semibold uppercase tracking-widest text-[var(--muted-foreground)]">
            {eyebrow}
          </span>
        )}
        <h1 className="text-2xl font-bold tracking-tight text-[var(--foreground)]">{title}</h1>
        {subtitle && <p className="text-sm text-[var(--muted-foreground)]">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
};

export default PageHeader;
